import { all } from 'redux-saga/effects';
import timerSagas from './timerSagas';
import filesSagas from './filesSagas';

export default function* rootSaga() {
  yield all([timerSagas(), filesSagas()]);
}
